import React, {useContext, useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import '../../css/subscription.css';
import TermsOfService from '../../terms/tos';
import image from '../../assets/icons/loading-loader.gif';
import { subscribeToProduct } from '../../utilities/subscriptionFunctions';
import { getProductData } from '../../utilities/subscriptionFunctions';
import { AgentContext } from '../../context/AgentContext';

const stripeProductId = process.env.REACT_APP_FUNNEL_STRIPE_PRODUCT_ID;
//#45bcaa8a
function SubscriptionWarning({card, customer, agent}) {
    const stripeB2bProduct = useSelector((state) => state.agent.userData.product_id);
    const [terms, setTerms] = useState(false);
    const [loading, setLoading] = useState(false);
    const [billingAgreement, setBillingAgreement] = useState(false);
    const [productInfo, setProductInfo] = useState({})
    const [stripePriceId, setStripePriceId] = useState(null);

    const {isB2B} = useContext(AgentContext)
    const productId = isB2B ? stripeB2bProduct : stripeProductId;

    const hydrateProductInfo = async () => {
        try {
            const productData = await getProductData(productId)

            if(productData.metadata.subscription_features){
                // subscription_features should be a CSV of features
                productData.metadata.subscription_features = productData.metadata.subscription_features.split(',')
            } else {
                productData.metadata.subscription_features = []
            }

            setProductInfo(productData.metadata ? {...productData.metadata,price:(productData, productData.default_price.unit_amount / 100)} : {}) // pricing info is in the meta data
            setStripePriceId(productData.default_price.id);
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(()=>{
        hydrateProductInfo()
    }, [])

    const handleSubscribe=async ()=>{
        setLoading(true)
        const subscription = await subscribeToProduct(stripePriceId, agent, card, customer);
        if(subscription){
            window.location.reload();
        }
        else{
            alert('there was a problem with your payment');
            setLoading(false)
        }

    }
    return (
        <div className="subscriptionWarningWrapper">
            <div className="subscriptionWarningTitle">Thank you for wanting to join the <b>Fun</b>nel Team <br/><br/><b>${productInfo.price} Per Month</b></div>
            <div className="subscribeInfoWrapper">
                <div className="quilityDataLine">
                    <TermsOfService terms={terms} setTerms={setTerms} setBillingAgreement={setBillingAgreement} />
                </div>
                <div className="quilityDataLine">
                    <div className={`${terms ? `${isB2B ? 'b2b ' : ''}solidQuilityActiveButton` : 'inactiveButton'} subscribeButton`} onClick={()=>terms ? handleSubscribe() : null}>Submit & Subscribe</div>
                </div>
            </div>
            {loading && (
                <div className="loadingScreen">
                    <div className="loaderWrapper">
                        <img src={image} alt="Loading Gif" style={{width: '100%'}} />
                    </div>
                </div>
            )}
        </div>
    );
}

export default SubscriptionWarning;
